module.exports = ".field{width:100%}\n"